import { Hash, Cog } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import TabelaAcoes from "./TabelaAcoes";
import Paginacao from "./Paginacao";

export default function TabelaTiposServicoTable({
  dados,
  filtro,
  setFiltro,
  colunaAtiva,
  setColunaAtiva,
  paginaAtual,
  setPaginaAtual,
  totalPaginas,
  itensPorPagina,
  setItensPorPagina,
  onEditar,
  onExcluir,
}) {
  return (
    <table className="w-full border-collapse">
      <thead>
        <tr className="text-white text-sm">
          {/* coluna código */}
          <th
            className={`w-[10%] px-2 py-3 text-center border border-slate-400 transition-colors ${
              colunaAtiva === "codigo" ? "bg-[#f95000]" : "bg-[#2b2b2b]"
            }`}
          >
            <div className="flex flex-col items-center">
              <div className="flex items-center gap-1">
                <Hash size={14} />
                <span>Código</span>
              </div>
              <input
                type="text"
                value={filtro.codigo}
                onFocus={() => setColunaAtiva("codigo")}
                onBlur={() => setColunaAtiva(null)}
                onChange={(e) =>
                  setFiltro({ ...filtro, codigo: e.target.value })
                }
                className="mt-2 w-full bg-transparent border-0 border-b border-white/40 text-white text-xs text-center focus:outline-none"
              />
            </div>
          </th>

          {/* coluna nome */}
          <th
            className={`w-[75%] px-2 py-3 text-center border border-slate-400 transition-colors ${
              colunaAtiva === "nome" ? "bg-[#f95000]" : "bg-[#2b2b2b]"
            }`}
          >
            <div className="flex flex-col items-center">
              <div className="flex items-center gap-1">
                <Cog size={14} />
                <span>Tipo de Serviço</span>
              </div>
              <input
                type="text"
                value={filtro.nome}
                onFocus={() => setColunaAtiva("nome")}
                onBlur={() => setColunaAtiva(null)}
                onChange={(e) =>
                  setFiltro({ ...filtro, nome: e.target.value })
                }
                className="mt-2 w-full bg-transparent border-0 border-b border-white/40 text-white text-xs text-center focus:outline-none"
              />
            </div>
          </th>

          <th className="w-[15%] px-2 py-3 text-center border border-slate-400 bg-[#2b2b2b]">
            Ações
          </th>
        </tr>
      </thead>

      {/* corpo com animação */}
      <AnimatePresence mode="wait">
        <motion.tbody
          key={paginaAtual}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.3 }}
        >
          {dados.length > 0 ? (
            dados.map((item) => (
              <tr
                key={item.id}
                className="odd:bg-white even:bg-slate-50 hover:bg-slate-100 transition-colors text-sm"
              >
                <td className="px-2 py-2 text-center border border-slate-300">
                  {item.codigo}
                </td>
                <td className="px-2 py-2 border border-slate-300">
                  {item.nome}
                </td>
                <td className="px-2 py-2 text-center border border-slate-300">
                  <TabelaAcoes
                    item={item}
                    onEditar={onEditar}
                    onExcluir={() => onExcluir(item)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={3}
                className="text-center py-4 text-slate-500 border border-slate-300"
              >
                Nenhum tipo de serviço encontrado.
              </td>
            </tr>
          )}
        </motion.tbody>
      </AnimatePresence>

      {/* rodapé com paginação */}
      {totalPaginas > 1 && (
        <tfoot>
          <tr>
            <td colSpan={3} className="p-0">
              <div className="w-full bg-[#2b2b2b] py-2 px-4">
                <Paginacao
                  paginaAtual={paginaAtual}
                  setPaginaAtual={setPaginaAtual}
                  totalPaginas={totalPaginas}
                  itensPorPagina={itensPorPagina}
                  setItensPorPagina={setItensPorPagina}
                />
              </div>
            </td>
          </tr>
        </tfoot>
      )}
    </table>
  );
}
